import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FieldOkComponent } from '@softline/dynamic';
import { UiCoreModule } from '@softline/ui-core';
import { Item } from '../../types/item';

@Component({
  selector: 'soft-esl-item-list',
  imports: [CommonModule, UiCoreModule, FieldOkComponent],
  templateUrl: './esl-item-list.component.html',
  styleUrls: ['./esl-item-list.component.scss'],
})
export class EslItemListComponent {
  readonly items = input.required<Item[]>();
  readonly itemCount = input.required<number>();

  removeItem = output<Item>();
  addItem = output<Item>();
  startScan = output();
  onSubmit = output();
}
